import { useState } from 'react'

export default function useFormInput(initialValue) {
  const [value, setValue] = useState(initialValue)

  function handleChange(eventOrValue) {
    if (eventOrValue && eventOrValue.target) {
      setValue(eventOrValue.target.value)
    } else if (eventOrValue !== undefined) {
      setValue(eventOrValue)
    }
  }

  return {
    value,
    onChange: handleChange
  }
}
